<template>
	<div class="videocon">
		<div class="breadcrumb">视频热度配置</div>
		<div class="topnav" style="margin:15px 0 30px">
	    	<li v-for="(item,index) in selData" :class="index==cur?'active':''" @click="topnav(index,item.id)">{{item.name}}</li>
	    </div>
	    <div style="width:40%; margin:0 auto" >
	    	<el-form :model="ruleForm1" ref="ruleForm" :rules="ruleForms1" status-icon label-width="70px">
		        <el-form-item label="最大值" prop="maxScore">
		          	<el-input v-model="ruleForm1.maxScore" placeholder="请输入最大值" @input="change($event)"></el-input>
		        </el-form-item>
		        <el-form-item label="权重系数" v-if="cur==3">
		          	<el-input v-model="ruleForm1.weightCoefficient" placeholder="请输入权重系数" @input="change($event)"></el-input>
		        </el-form-item>

			  	<el-form-item label="配置" v-if="cur!=3">
				    <el-button type="primary" style="margin-bottom:20px" @click="addLine1">添加行</el-button>
		        	<el-table :data="ruleForm1.tableData" style="width: 100%" border class="paytab" v-if="ruleForm1.tableData.length>0">
				      	<el-table-column label="区间值" >
				      		<template slot-scope="scope">
				      			<div style="display:flex">
				      				<el-input v-model="scope.row.startSection" ></el-input>-
					            	<el-input v-model="scope.row.endSection" ></el-input>
				      			</div>
				            </template>
				      	</el-table-column>
				      	<el-table-column prop="weightCoefficient" label="系数" width='110'>
				      		<template slot-scope="scope">
				      			<el-input v-model="scope.row.weightCoefficient" ></el-input>
				      		</template>
				      	</el-table-column>
				      	<el-table-column prop="num" label="分值" width='110'>
				      		<template slot-scope="scope">
				      			<div v-if="scope.row.weightCoefficient && ruleForm1.maxScore">{{scope.row.weightCoefficient*ruleForm1.maxScore}}</div>
				      		</template>
				      	</el-table-column>
				      	<el-table-column  label="操作" width='110'>
				      		<template slot-scope="scope">
				      			<el-button type="primary" size='small' @click="deleteRow1(scope.$index,ruleForm1.tableData,scope.row)">删除</el-button>
				      		</template>
				      	</el-table-column>
				    </el-table>
			  	</el-form-item>
			  	<el-form-item>
			  		<el-button type="primary" @click="addShortVideoDictionary1">保存</el-button>
			  	</el-form-item>
			  	
	  		</el-form>	
	    </div>
	    
	</div>
</template>
<script>
export default {
	components: {
	},
  	mounted() {
		this.init();
  	},
  	data() {
    	return {
    		selData:[
    			{name:'分享次数',id:1},
    			{name:'评论次数',id:2},
    			{name:'观看次数',id:3},
    			{name:'置顶',id:4},
    			{name:'视频发布时长',id:6},
    		],
    		cur:0,
    		ruleForm1:{
    			maxScore:'',
    			tableData: []
    		},
    		ruleForms1:{},
    		istopId:'',
    		navId:1
	    };
  	},
  	methods:{
  		change(e){
  			this.$forceUpdate()
  		},
  		topnav(e,id){
 			this.cur=e;
 			this.navId=id;
 			this.ruleForm1={
    			maxScore:'',
    			tableData: []
    		}
 			this.init();
 		},
 		addLine1() {
	      	var newValue = {};
	      	this.ruleForm1.tableData.push(newValue);
	    },
	    delLine1() {//删除行数
	    	this.ruleForm1.tableData.pop();	
	    },
	    deleteRow1(index,rows,row){
	    	rows.splice(index, 1);
	    	if(row.id){
	    		this.$post('/shortVideo/delShortVideoDictionary', JSON.stringify(row))
	        	.then(res => {
	        		console.log(res)
	          		if(res.code==0){
	          			this.$message({
		                    message: "删除成功",
		                    type: "success"
	                  	});
	          		}else {
	            		this.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
	    	}
	    },
	    init(){
	    	var params = {
        		type:this.navId
      		};
      		this.$get("/shortVideo/queryShortVideoDictionary", params)
        	.then(res => {
        		console.log(res)
          		if (res.code == 0) {
          			this.ruleForm1.tableData=res.data;
            		if(res.data.length>0){
            			this.ruleForm1.maxScore=res.data[0].maxScore;
            			this.ruleForm1.weightCoefficient=res.data[0].weightCoefficient;
            			this.istopId=res.data[0].id;
            		}
          		}else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
	    },
	    addShortVideoDictionary1(){
	    	if(!this.ruleForm1.maxScore){
	    		this.$message({
          			message: '最大值不能为空',
          			type: "warning"
        		});
        		return false
	    	}
	    	if(this.cur!=3){
	    		if(this.ruleForm1.tableData.length<1){
		    		this.$message({
	          			message: '请至少添加一条吧~',
	          			type: "warning"
	        		});
	        		return false
		    	}
		    	for(var i=0;i<this.ruleForm1.tableData.length;i++){
		    		this.ruleForm1.tableData[i].maxScore=this.ruleForm1.maxScore;
		    		this.ruleForm1.tableData[i].dicType=this.navId;
		    		if(this.ruleForm1.tableData[i].maxScore && (this.ruleForm1.tableData[i].startSection || this.ruleForm1.tableData[i].startSection==0) && this.ruleForm1.tableData[i].endSection && this.ruleForm1.tableData[i].weightCoefficient){
		    			
		    		}else{
		    			this.$message({
	              			message: '输入框不能为空',
	              			type: "warning"
	            		});
	            		return false;
		    		}
		    	}
	    	}else{
	    		if(!this.ruleForm1.weightCoefficient){
	    			this.$message({
	          			message: '权重系数不能为空',
	          			type: "warning"
	        		});
	        		return false
	    		}
	    		this.ruleForm1.tableData=[{maxScore:this.ruleForm1.maxScore,weightCoefficient:this.ruleForm1.weightCoefficient,dicType:this.navId,id:this.istopId}]
	    	}
			this.$post('/shortVideo/addShortVideoDictionary', JSON.stringify(this.ruleForm1.tableData))
        	.then(res => {
        		console.log(res)
          		if(res.code==0){
          			this.$message({
	                    message: "保存成功",
	                    type: "success"
                  	});
                  	this.init()
          		}else {
            		this.$message({
              			message: res.message,
              			type: "warning"
            		});
            		return false;
          		}
        	})
	    }
  	}
}
</script>
<style>
.el-table .cell{
	line-height: inherit;
}
</style>


// WEBPACK FOOTER //
// src/views/videoList/videoConfiguration.vue